import { useSearch, useSiteContext, useTranslation } from '@eti/providers';
import { useHistory } from 'react-router-dom';
import { routes as routesConstants } from '../../../../constants/routesAndApisConstants';
import ErrorDialog from '../../../../common/error-modals/ErrorDialog';
import { PAYMENT_NO_RESERVATIONS_IN_CART } from '../../../../constants/dataLayerEventsConstants';

const EmptyCartDialog = () => {
  const { agencyAccount } = useSiteContext();
  const { t } = useTranslation();
  const history = useHistory();
  const { currentSearchData } = useSearch();
  const redirectDestination = currentSearchData?.routes
    ? routesConstants.RESULT
    : routesConstants.START;

  return (
    <ErrorDialog
      content={t('EmptyCart.Content.Text')}
      data-testid="cartTimeoutDialog"
      dataLayerEvent={PAYMENT_NO_RESERVATIONS_IN_CART}
      isOpen
      onPrimaryAction={!agencyAccount ? () => history.push(redirectDestination) : undefined}
      primaryButtonLabel={!agencyAccount ? t('EmptyCart.Button.Text') : undefined}
      title={t('EmptyCart.Heading')}
    />
  );
};

export default EmptyCartDialog;
